import TextManager from '@/utils/text-manager.utils'

import INSTALLMENTS_LABELS from './installments.labels'

class InstallmentsManager {
  installments
  constructor (installments) {
    this.installments = installments
  }

  defaultStructure = Object.keys(INSTALLMENTS_LABELS)

  /**
   * parseLabel takes in a single parameter label and returns a string value by matching the label parameter
   * with the key of an object validationLabel.
   * @param {String} label the label to convert
   * @returns String
   */
  parseLabel (label) {
    const validationLabel = {
      ...INSTALLMENTS_LABELS
    }
    return validationLabel[label] ?? TextManager.formatTextSnakeOrCamel(label)
  }

  /**
   * Executes all the methods
   * @returns Array
   */

  sort () {
    const installmentsValidation = {
      one: 1,
      'two-to-three': 2,
      'four-to-six': 3,
      'seven-to-nine': 4,
      'ten-to-twelve': 5,
      'greater-than-twelve': 6
    }

    const installments = this.installments.map(item => {
      return { ...item, ordination: installmentsValidation[item.name] }
    })

    const sortedItems = installments.sort((a, b) => a.ordination - b.ordination)

    this.installments = sortedItems
  }

  adapter () {
    const installments = this.installments

    const data = installments.map(item => item.quantity)
    const label = installments.map(item => this.parseLabel(item.name))

    this.installments = {
      data,
      label,
      minBarLength: 5
    }
  }

  get () {
    this.sort()
    this.adapter()

    return this.installments
  }
}

export default InstallmentsManager
